export const SET_FETCHING_FUND_ANALYSIS = 'analysis/SET_FETCHING_FUND_ANALYSIS';
export const SET_FUND_ANALYSIS = 'analysis/SET_FUND_ANALYSIS';
export const SET_SCHEME_ANALYSIS = 'analysis/SET_SCHEME_ANALYSIS';
export const SET_SUBMISSION_SUMMARY = 'analysis/SET_SUBMISSION_SUMMARY';
export const SET_SUBFUND_ANALYSIS = 'analysis/SET_SUBFUND_ANALYSIS';
export const SET_CONSULTANT_ANALYSIS = 'analysis/SET_CONSULTANT_ANALYSIS';
export const SET_PROVIDER_ANALYSIS = 'analysis/SET_PROVIDER_ANALYSIS';
export const SET_FIDUCIARY_ANALYSIS = 'analysis/SET_FIDUCIARY_ANALYSIS';
